import React from 'react';
import { useNavigate } from 'react-router-dom';
import { signOut } from 'firebase/auth';
import { auth } from '../../firebaseConfig';
import { useAuth } from '../AuthContext';

export default function AdminSettings() {
  const { currentUser } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    if (!window.confirm('Yakin ingin logout?')) return;
    await signOut(auth);
    navigate('/login');
  };

  return (
    <div className="admin-page">
      <div className="admin-page-header">
        <div>
          <h2>Pengaturan Admin</h2>
          <p className="text-muted-small">
            Kelola akses admin dan informasi akun yang sedang aktif.
          </p>
        </div>
      </div>

      <div className="admin-card">
        <h3>Akun</h3>
        <div className="text-muted-small">Login sebagai</div>
        <div className="fw-semibold">{currentUser?.email || '-'}</div>
        <div className="text-muted-small mt-2">UID: {currentUser?.uid || '-'}</div>
        <div className="admin-form-actions mt-3">
          <button className="admin-logout-secondary" onClick={handleLogout}>
            <i className="bi bi-box-arrow-right"></i>
            Logout
          </button>
        </div>
      </div>

      <div className="admin-card">
        <h3>Tambah Admin</h3>
        <p className="text-muted-small mb-2">
          Akses admin ditentukan oleh custom-claim <code>isAdmin=true</code>. Untuk menambah admin, jalankan skrip
          <code> npm run create-admin</code> di komputer lokal dengan service account.
        </p>
        <pre className="admin-code-block">
          npm run create-admin -- --email=admin@example.com --password=StrongPass123! --key=./serviceAccount.json
        </pre>
      </div>
    </div>
  );
}
